export default __webpack_public_path__ + "static/media/back-button-white.40794686.svg";